import React, { useState, forwardRef, useImperativeHandle,useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddTechnician = forwardRef((props, ref) => {
    const [inviteModal, setInviteModal] = useState(false);

    // Using useImperativeHandle to expose the modal opening function
    useImperativeHandle(ref, () => ({
        showInviteModal() {
            setInviteModal(true);
        }
    }));

    // Form state
    const [formData, setFormData] = useState([])

    const [errors, setErrors] = useState(null); // Handling errors
    useEffect(() => {
        if (props.data) {
          setFormData(props.data);
          console.log(props.data)
        }
      }, [props.data]);
    // Handle form field change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Handle form submit
   
    const handleSubmit = ev => {
        ev.preventDefault()
        setErrors('')  
        const phone = formData.Phone ? String(formData.Phone) : ''; 

    if (!phone.match(/^(218)?09[123456][0-9]{7}$/)) {
        setErrors('رقم الهاتف  : 00 00 000 091 او 00 00 000 092');
        console.log(errors);
    }
        else{
        axios.put(`https://subk.education.com.ly/back/api/technicians/${formData.TechnicianID}`, formData)
        .then(() => {
            setFormData('')
            props.parentFunction()
        setErrors('')  
        setFormData('')
        toast.success('Technician updated successfully!');
        setInviteModal(false)
        })
        .catch(function (error) {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
         
        }
        }
        useEffect(() => {
        const handleEnterKey = (e) => {
        if (e.key === 'Enter') {
        e.preventDefault();
        const form = e.target.form;
        const fields = Array.from(form.elements).filter(el => (
          (el.tagName === 'INPUT' && !el.disabled) ||
          (el.tagName === 'TEXTAREA' && !el.disabled) ||
          (el.tagName === 'SELECT' && !el.disabled)
        ));      const currentFieldIndex = fields.findIndex(el => el === document.activeElement);
        const nextFieldIndex = currentFieldIndex + 1;
        if (nextFieldIndex < fields.length) {
          fields[nextFieldIndex].focus();
        }
        }
        };
        
        document.addEventListener('keydown', handleEnterKey);
        
        return () => {
        document.removeEventListener('keydown', handleEnterKey);
        };
        }, []);
    return (
        <>
            <ToastContainer />
            <Modal className="modal fade" show={inviteModal} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">تعديل بيانات الفني</h1>
                        <button
                            type="button"
                            className="btn-close"
                            style={{ marginLeft: 0 }}
                            onClick={() => setInviteModal(false)}
                        ></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xl-12">
                                    {errors && <div className="alert alert-danger">{errors}</div>}
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">الاسم <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="FirstName"
                                        value={formData.FirstName}
                                        onChange={handleChange}
                                        required
                                         pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">اللقب<span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="LastName"
                                        value={formData.LastName}
                                        onChange={handleChange}
                                          pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">التخصص <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="Specialization"
                                        value={formData.Specialization}
                                        onChange={handleChange}
                                         pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">ساعات العمل <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="number"
                                        name="HourlyRate"
                                        value={formData.HourlyRate}
                                        onChange={handleChange}
                                        
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">تاريخ التعين <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        name="HireDate"
                                        value={formData.HireDate}
                                        onChange={handleChange}
                                     
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">رقم الهاتف</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="Phone"
                                        value={formData.Phone}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">البريد الالكتروني<span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        name="Email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                       
                                    />
                                </div>

                               <div className="col-xl-6">
  <label className="form-label mt-3">
    الراتب <span className="text-danger">*</span>
  </label>
  <input
    className="form-control"
    type="number"
    name="Salary"
    value={formData.SalaryAmount ?? formData.Salary ?? ""}
    onChange={(e) => {
      const value = e.target.value;
      if (formData.SalaryAmount != null) {
        // editing fixed salary
        setFormData({ ...formData, SalaryAmount: value });
      } else {
        // editing percentage
        setFormData({ ...formData, Salary: value });
      }
    }}
    required
  />
</div>

                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="submit" className="btn btn-primary">حفظ</button>
                            <button
                                type="button"
                                className="btn btn-danger light"
                                onClick={() => setInviteModal(false)}
                            >
                                الغاء
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
});

export default AddTechnician;
